module.exports = __webpack_public_path__ + "static/media/Room types lightning.302e81c9.svg";